import { Button, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const ReconsentError = ({
    onRetry,
    onClose
}: {
    onRetry: () => void;
    onClose: () => void;
}) => {
    return (
        <div className="space-y-l">
            <Text size="s" className="font-bold">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.error_heading"
                    defaultMessage="Something went wrong"
                />
            </Text>
            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.error_body"
                    defaultMessage="We couldn’t update your bank connection just now. Nothing has changed, so you can try again."
                />
            </Text>
            <div className="space-y-s">
                <Button
                    variant="primary-rounded"
                    className="w-full"
                    onClick={onRetry}
                >
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.error_retry"
                        defaultMessage="Try again"
                    />
                </Button>
                <Button variant="tertiary" className="w-full" onClick={onClose}>
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.error_close"
                        defaultMessage="I’ll do this later"
                    />
                </Button>
            </div>
        </div>
    );
};
